import { OktaAuth } from "@okta/okta-auth-js";
import oktaConfig from "./config";

export const oktaAuth = new OktaAuth(oktaConfig);
